<template>
  <v-row class=" service-main-wrapper">
    <!-- Start Single Service  -->
    <v-col
      lg="4"
      md="4"
      sm="6"
      cols="12"
      v-for="(service, i) in serviceContent"
      :key="i"
    >
      <div class="service service__style--2 text-left bg-gray">
        <router-link to="/service">
          <div class="service">
            <div class="icon">
              <div v-html="iconSvg(service.icon)"></div>
            </div>
            <div class="content">
              <h3 class="heading-title">{{ service.title }}</h3>
              <p>
                {{ service.desc }}
              </p>
            </div>
          </div>
        </router-link>
      </div>
    </v-col>
    <!-- End Single Service  -->
  </v-row>
</template>

<script>
  import feather from "feather-icons";
  export default {
    data() {
      return {
        serviceContent: [
          {
            icon: "code",
            title: "Backend Development",
            desc: `Expert backend development using Laravel/PHP, Node.js, and Python/Django. Building robust, scalable, and secure server-side applications.`,
          },
          {
            icon: "layout",
            title: "Frontend Development",
            desc: `Modern frontend development with Vue.js, Nuxt.js, React.js, and Vuetify. Creating responsive and interactive user interfaces.`,
          },
          {
            icon: "database",
            title: "Database Solutions",
            desc: `Comprehensive database management across MySQL, MSSQL, PostgreSQL, MongoDB, and Firebase. Optimizing data storage and retrieval.`,
          },
          {
            icon: "smartphone",
            title: "Mobile Development",
            desc: `Cross-platform mobile development using Flutter, Ionic, and Framework7. Building native-like mobile experiences.`,
          },
          {
            icon: "server",
            title: "API Development",
            desc: `RESTful API development and integration using Node.js/Prisma.js. Creating efficient and secure data exchange systems.`,
          },
          {
            icon: "shield",
            title: "Full Stack Solutions",
            desc: `End-to-end development solutions combining all our expertise to deliver complete, integrated applications.`,
          },
        ],
      };
    },
    methods: {
      iconSvg(icon) {
        return feather.icons[icon].toSvg();
      },
    },
  };
</script>
